'use client';

import { useTranslation } from '@/context/LanguageContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen, faLightbulb, faHandshake, faLeaf } from '@fortawesome/free-solid-svg-icons';

export default function CoreValuesSectionClient() {
    const { t } = useTranslation();

    const values = [
        {
            icon: faBookOpen,
            title: t('coreValues.integrity') || 'Integritas',
            desc: t('coreValues.integrityDesc') || 'Menjunjung tinggi kejujuran dan etika dalam segala aspek akademik dan organisasi.',
            color: 'bg-unmulGreen',
            gradient: 'from-emerald-50 to-emerald-100',
            textColor: 'text-white'
        },
        {
            icon: faLightbulb,
            title: t('coreValues.innovation') || 'Inovasi',
            desc: t('coreValues.innovationDesc') || 'Mendorong kreativitas dan pemikiran baru untuk solusi tantangan masa depan.',
            color: 'bg-unmulYellow',
            gradient: 'from-yellow-50 to-yellow-100',
            textColor: 'text-unmulDarkGreen'
        },
        {
            icon: faHandshake,
            title: t('coreValues.collaboration') || 'Kolaborasi',
            desc: t('coreValues.collaborationDesc') || 'Membangun kemitraan yang kuat dengan berbagai pihak untuk kemajuan bersama.',
            color: 'bg-blue-600',
            gradient: 'from-blue-50 to-blue-100',
            textColor: 'text-white'
        },
        {
            icon: faLeaf,
            title: t('coreValues.sustainability') || 'Keberlanjutan',
            desc: t('coreValues.sustainabilityDesc') || 'Berkomitmen untuk kelestarian lingkungan dan pembangunan berkelanjutan.',
            color: 'bg-green-600',
            gradient: 'from-green-50 to-green-100',
            textColor: 'text-white'
        }
    ];

    return (
        <section className="py-20 bg-white">
            <div className="container mx-auto px-6">
                <div className="text-center mb-16" data-aos="fade-up">
                    <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900">
                        {t('coreValues.title') || 'Nilai-Nilai'} <span className="text-unmulGreen">{t('coreValues.subtitle') || 'Inti'}</span>
                    </h2>
                    <p className="text-gray-500 mt-4 max-w-2xl mx-auto">
                        {t('coreValues.description') || 'Prinsip yang kami pegang teguh dalam menjalankan Tri Dharma Perguruan Tinggi'}
                    </p>
                </div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {values.map((item, index) => (
                        <div
                            key={index}
                            className={`bg-gradient-to-br ${item.gradient} p-6 rounded-2xl text-center hover:shadow-xl transition transform hover:-translate-y-2`}
                            data-aos="fade-up"
                            data-aos-delay={index * 100}
                        >
                            <div className={`w-16 h-16 ${item.color} rounded-full flex items-center justify-center mx-auto mb-4`}>
                                <FontAwesomeIcon icon={item.icon} className={`${item.textColor} text-2xl`} />
                            </div>
                            <h4 className="text-xl font-bold text-gray-800 mb-2">{item.title}</h4>
                            <p className="text-gray-600 text-sm">{item.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
